<lib-sales-insights-card
  [cardTitle]="config?.title"
  [subtitle]="subtitle"
  [loading]="loading"
  [error]="error"
  [empty]="empty"
>
  <div class="si-chart">
    <canvas baseChart type="bar" [labels]="labels" [datasets]="datasets" [options]="chartOptions"></canvas>
  </div>
</lib-sales-insights-card>
